import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, sections), helpers), {}, {
  pageWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between'
  },
  pageWrapperNav: {
    width: '300px',
    flexShrink: '0',
    position: 'relative',
    backgroundColor: palette.common.white,
    height: 'calc(100vh - 74px)',
    borderRight: "1px solid ".concat(palette.shades[300])
  },
  pageWrapperNavWrapper: {
    overflow: 'auto',
    height: 'calc(100vh - 232px)'
  },
  pageWrapperNavItem: {
    padding: '16px 24px',
    color: palette.common.black,
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    borderTop: "1px solid ".concat(palette.shades[300]),
    borderBottom: "1px solid ".concat(palette.shades[300]),
    marginTop: '-1px',
    position: 'relative',
    '&:hover': {
      backgroundColor: palette.shades[200]
    },
    '&.active:after': {
      top: '0',
      right: '0',
      bottom: '0',
      width: '2px',
      content: '""',
      display: 'block',
      position: 'absolute',
      background: '#009299'
    }
  },
  pageWrapperNavAddNew: {
    padding: '16px',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    '& .MuiButton-root': {
      width: '100%'
    }
  },
  pageWrapperNavSearch: {
    padding: '15px',
    marginTop: '80px',
    borderTop: "1px solid ".concat(palette.shades[300]),
    borderBottom: "1px solid ".concat(palette.shades[300]),
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  pageWrapperNavSearchInput: {
    width: '100%',
    paddingRight: '4px'
  },
  pageWrapperNavSearchFilter: {
    '& .MuiButton-root': {
      padding: '11px 11px',
      border: '1px solid #b6c2cc',
      minWidth: '48px'
    }
  },
  pageWrapperContent: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    padding: '24px 50px'
  },
  pageWrapperContentWrapper: {
    width: '100%',
    padding: '24px 40px',
    backgroundColor: palette.common.white,
    height: 'calc(100vh - 120px)',
    '&.center': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  pageWrapperContentTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .MuiTypography-root': {
      marginRight: '8px'
    }
  },
  pageWrapperContentDetailsList: {
    display: 'flex',
    marginTop: '24px',
    '& dl': {
      padding: '0 16px',
      fontWeight: '600',
      '&:not(:first-child)': {
        borderLeft: "1px solid ".concat(palette.shades[300])
      }
    },
    '& dt': {
      color: palette.shades[700],
      fontSize: '13px'
    },
    '& dd': {
      color: palette.common.black,
      fontSize: '15px',
      margin: '0'
    }
  },
  pageWrapperContentProperties: {
    marginTop: '24px',
    position: 'relative',
    '& .MuiTableCell-root:first-of-type': {
      width: '80px'
    },
    '&.selected': {
      paddingBottom: '60px'
    }
  },
  pageWrapperContentPropertiesSearch: {
    marginBottom: '24px'
  },
  pageWrapperContentPropertiesList: {
    width: '100%',
    overflow: 'auto',
    height: 'calc(100vh - 392px)'
  },
  formWrapperItem: {
    marginBottom: '24px'
  },
  multiActions: {
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '1',
    display: 'flex',
    position: 'fixed',
    borderRadius: '2px',
    padding: '20px 90px',
    alignItems: 'center',
    backgroundColor: palette.common.white,
    justifyContent: 'flex-end',
    boxShadow: '0px 4px 24px rgba(85, 100, 119, 0.08)'
  },
  multiActionsTitle: {
    fontWeight: '600'
  },
  multiActionsItems: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiButton-root': {
      marginLeft: '16px'
    }
  },
  modalSearch: {
    padding: '20px 24px'
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  noResult: {
    textAlign: 'center',
    padding: '24px'
  },
  address: {
    display: 'block',
    maxWidth: '360px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  inlineTitle: {
    display: 'flex',
    whiteSpace: 'nowrap',
    alignItems: 'center'
  }
}));
export default useStyles;